<template>
  <section
    id="saleInfo"
  >
    <div class="row">
      <label class="label">
        Piyasa Satış Fiyatı (KDV Dahil)
        <span class="required">*</span>
      </label>
      <div>
        <GInputPrice
          v-model="product.listPrice"
          @focus="setCaretPosition"
          data-vv-as="Piyasa Satış Fiyatı"
          v-validate="{ required: true }"
          :class="{'is-invalid' : errors.has('listPrice')}"
          name="listPrice"
        />
        <div class="invalid-feedback">
          {{ errors.first('listPrice') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="label">
        Trendyol’da Satış Fiyatı (KDV Dahil)
        <span class="required">*</span>
      </label>
      <div>
        <GInputPrice
          v-model="product.salePrice"
          @focus="setCaretPosition"
          name="salePrice"
          v-validate="{ required: true, isLth: product.listPrice }"
          :class="{'is-invalid' : errors.has('salePrice')}"
          data-vv-as="Trendyol’da Satış Fiyatı"
          @click="trackEvent('price')"
        />
        <div class="invalid-feedback">
          {{ errors.first('salePrice') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="label">
        KDV
        <span class="required">*</span>
      </label>
      <div>
        <Select
          v-model="product.vatRateOption"
          name="vatRate"
          data-vv-as="KDV"
          v-validate="{ required: true }"
          :class="{'is-invalid' : errors.has('vatRate')}"
          data-vv-validate-on="change|input"
          :options="vatRateOptions"
        />
        <div class="invalid-feedback">
          {{ errors.first('vatRate') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="label">
        Stok
        <span class="required">*</span>
      </label>
      <div>
        <GInputQuantity
          v-model="product.quantity"
          v-validate="{ required: true, configMax: true }"
          name="quantity"
          data-vv-as="Stok"
          :class="{'is-invalid' : errors.has('quantity')}"
          @click="trackEvent('quantity')"
        />
        <div class="invalid-feedback">
          {{ errors.first('quantity') }}
        </div>
      </div>
    </div>
    <div
      class="row"
    >
      <label class="label">
        Trendyol Komisyonu
      </label>
      <div>
        <div class="form-control disabled">
          {{ getCommission }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="label">
        Ödeme Vadesi
      </label>
      <div>
        <div class="form-control disabled">
          {{ product.paymentTerm }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="label">
        Maksimum Ürün Adedi
      </label>
      <div>
        <div class="form-control disabled">
          {{ product.maxSaleQuantity || '-' }}
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import inventoryCenterService from '@/services/inventoryCenter';
import InputMask from '@/directives/InputMask';
import setCaretPosition from '@/mixins/setCaretPosition';
import format from '@/utils/format';
import Select from '@/components/Select';
import GInputPrice from '@trendyol-js/grace/core/GInputPrice';
import GInputQuantity from '@/components/GInputQuantity';

export default {
  name: 'ProductSaleInfo',
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    GInputQuantity,
    Select,
    GInputPrice,
  },
  directives: {
    mask: InputMask,
  },
  data () {
    return {
      vatRateOptions: [
        {
          label: '%0',
          value: 0,
        },
        {
          label: '%1',
          value: 1,
        },
        {
          label: '%10',
          value: 10,
        },
        {
          label: '%20',
          value: 20,
        },
      ],
    };
  },
  computed: {
    getCommission () {
      const commission = parseFloat(format.priceToNumber(this.product.salePrice) * (this.product.commission / 100)).toFixed(2);
      return `${commission}₺ (%${this.product.commission})`;
    },
  },
  mixins: [setCaretPosition],
  methods: {
    async getInventoryCenterHistory () {
      if (this.product.approved && this.product.platformListingId) {
        await inventoryCenterService.getInventoryCenterHistory(this.product.platformListingId);
      }
    },
    async validate () {
      const isValid = await this.$validator.validateAll();
      return isValid;
    },
    trackEvent (type) {
      const events = {
        quantity: {
          eventAction: 'stockclick',
          eventLabel: 'stockclick',
        },
        price: {
          eventAction: 'priceclick',
          eventLabel: 'priceclick',
        },
      };

      this.$root.trackEvent({
        eventCategory: 'MobileAppListing',
        ...events[type],
      });
    },
  },
  created () {
    this.getInventoryCenterHistory();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .g-input .body .g-field-wrapper .content {
  border-radius: 4px;
  border: solid 1px #dee0eb;
  height: 40px;
  input {
    font-size: 1rem !important;
  }
}
</style>
